import React from 'react';
import { SearchMessage } from '../../components';
import { SplitQueryString } from '../../../../shared/services/QueryString/QueryString';
import { GetSearchMessage } from '../../../../shared/services/SearchMessage/SearchMessage';

export default class SearchMessageContainer extends React.Component {
  constructor(props) {
    super(props);
    const rsWebProductModel = window.rs.web.product.model;
    let messages = { noResultsFound: undefined, showingResultsFor: undefined };
    const relevancyData = 'relevancy-data';

    if (window.location.search && window.location.search.indexOf(relevancyData)) {
      const items = SplitQueryString();
      messages = GetSearchMessage(items[relevancyData]);
    }
    this.state = { messages, labels: rsWebProductModel.labels.search };
  }

  render() {
    return (
      <SearchMessage messages={this.state.messages} labels={this.state.labels} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/containers/SearchMessageContainer/SearchMessageContainer.js